// extracted by mini-css-extract-plugin
export default {"container":"Team_container__uJ8Uq","character":"Team_character__DHsmJ","weapon":"Team_weapon__+Ju7F","item":"Team_item__siqUZ","img":"Team_img__ik1ex","level":"Team_level__bFCso"};